import type { IconDefaultProps } from './types'

const CircleXMark = ({ className }: IconDefaultProps): JSX.Element => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 25 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 0C5.34375 0 0 5.39062 0 12C0 18.6562 5.34375 24 12 24C18.6094 24 24 18.6562 24 12C24 5.39062 18.6094 0 12 0ZM12 22.5C6.1875 22.5 1.5 17.8125 1.5 12C1.5 6.23438 6.1875 1.5 12 1.5C17.7656 1.5 22.5 6.23438 22.5 12C22.5 17.8125 17.7656 22.5 12 22.5ZM16.9688 6.1875C16.6406 5.95312 16.1719 5.95312 15.8906 6.28125L12 10.875L8.0625 6.28125C7.78125 5.95312 7.3125 5.95312 6.98438 6.1875C6.65625 6.46875 6.65625 6.9375 6.89062 7.26562L10.9688 12L6.89062 16.7812C6.65625 17.1094 6.65625 17.5781 6.98438 17.8594C7.125 17.9531 7.3125 18 7.5 18C7.6875 18 7.875 17.9531 8.0625 17.7656L12 13.1719L15.8906 17.7656C16.0781 17.9531 16.2656 18 16.5 18C16.6406 18 16.8281 17.9531 16.9688 17.8594C17.2969 17.5781 17.2969 17.1094 17.0625 16.7812L12.9844 12L17.0625 7.26562C17.2969 6.9375 17.2969 6.46875 16.9688 6.1875Z'
      fill='currentColor'
    />
  </svg>
)

export default CircleXMark
